import Color from "color";
import { type CoreValueItem } from "@/lib/backend/api";
import { cx } from "@/lib/style/cva.config";

export function CoreValueBubble({
	value,
	transform,
}: {
	value: Pick<CoreValueItem, "id" | "emoji" | "color">;
	transform?: {
		scale?: number;
		left?: number | string;
		right?: number | string;
		bottom?: number | string;
		top?: number | string;
	};
}) {
	const { emoji, color } = value;

	return (
		<div
			className={cx("flex items-center justify-center rounded-full font-semibold", {
				absolute:
					transform?.left !== undefined ||
					transform?.right !== undefined ||
					transform?.bottom !== undefined ||
					transform?.top !== undefined,
			})}
			style={{
				background: Color(color).alpha(0.25).rgb().toString(),
				width: `${transform?.scale ?? 3}rem`,
				height: `${transform?.scale ?? 3}rem`,
				fontSize: `${(transform?.scale ?? 3) - 1.75}rem`,
				left: transform?.left,
				right: transform?.right,
				bottom: transform?.bottom,
				top: transform?.top,
			}}
		>
			<span>{emoji}</span>
		</div>
	);
}
